import { FunctionComponent as F, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Typography from '@mui/material/Typography';
import { HOME } from "../core/router/paths";
import { Link, Stack } from "@mui/material";
import Container from "../components/UI/Container/Container";
import { postOrderReminder } from "../core/http/user";


interface Params
{
  userId?: string,
  userIdHash?: string
}

const Unsubscribe: F = () =>
{
  const navigate = useNavigate();
  const params = useParams() as Params;

  const userId = Number(params.userId);
  const userIdHash = params.userIdHash;

  const handleResubscribe = () =>
  {
    if(!userId || !userIdHash)
      return setMessage(failureMessage());

    postOrderReminder({ active: true }, { userId, hash: userIdHash })
      .then(data =>
      {
        if(!data?.success)
          return setMessage(failureMessage());

        setMessage(
          <Typography variant='body2'>
            {"Successfully resubscribed 👍"}
          </Typography>);
      });
  }

  const inProgressMessage =
    <Typography variant='body2'>
      {"Unsubscribing..."}
    </Typography>;

  const successMessage =
    <Stack spacing={4}>
      <Typography variant='body2'>
        {"Unsubscribed from order reminder emails 👋"}
      </Typography>
      <Stack direction='row' spacing={2} alignItems="flex-end">
        <Typography variant='body2'>
          {"Unsubscribed by mistake?"}
        </Typography>
        <Link
          id='Account'
          variant='body2'
          onClick={handleResubscribe}
          style={{ cursor: 'pointer', fontSize: 12 }}>
          {"Resubscribe"}
        </Link>
      </Stack>
    </Stack>;

  const failureMessage = (subscribe = true) =>
    <Typography variant='body2'>
      {"Failed to " + (subscribe ? "re" : "un") + "subscribe - developer will be notified"}
    </Typography>;

  const [message, setMessage] = useState(inProgressMessage);

  useEffect(() =>
  {
    if(!userId || !userIdHash)
      return navigate(HOME);

    postOrderReminder({ active: false }, { userId, hash: userIdHash })
      .then(data =>
      {
        if(data?.success)
          setMessage(successMessage);
        else
          setMessage(failureMessage(false));
      });
  }, []);

  return (
    <Container width='100%'>
      {message}
    </Container>);
};

export default Unsubscribe;
